import React from 'react'
import CustomSelect from '../../../../components/CustomSelect/CustomSelect'

/**
 * ⚙️ Дополнительно — режимы расчёта, отображение.
 * Формула расчёта вынесена в SalaryFormulaSummary.
 */
export default function AdvancedSection({ settings, onChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {/* Режимы расчёта */}
      <div>
        <div style={{
          fontSize: '13px', fontWeight: 700, color: 'var(--text-tertiary)',
          textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px'
        }}>
          Режимы расчёта
        </div>
        <div className="salary-config-grid">
          <div className="salary-config-item">
            <div className="salary-config-icon"></div>
            <div className="salary-config-field">
              <label>Расчёт бонусов на смене</label>
              <CustomSelect
                value={settings.bonusCalculationMethod || 'individual'}
                onChange={(val) => onChange('bonusCalculationMethod', val)}
                options={[
                  { value: 'individual', label: 'Индивидуально (по личным логам)' },
                  { value: 'collective_pool_split', label: 'Разделение общего объема ПВЗ поровну' },
                ]}
              />
              <div style={{ fontSize: '11.5px', color: 'var(--text-secondary)', marginTop: '6px', lineHeight: '1.4' }}>
                {settings.bonusCalculationMethod === 'collective_pool_split' ? (
                  <span>👥 <strong>Деление поровну:</strong> все принятые/выданные/возвращённые товары за день на ПВЗ суммируются и делятся поровну между всеми сотрудниками в смене. Удобно для совместной работы.</span>
                ) : (
                  <span>👤 <strong>Индивидуально:</strong> каждый сотрудник получает бонусы только за те товары, которые он лично отсканировал под своим аккаунтом.</span>
                )}
              </div>
            </div>
          </div>
          <div className="salary-config-item">
            <div className="salary-config-icon"></div>
            <div className="salary-config-field">
              <label>Режим оклада за выход</label>
              <CustomSelect
                value={settings.dailyRateMode || 'config'}
                onChange={(val) => onChange('dailyRateMode', val)}
                options={[
                  { value: 'config', label: 'Фиксированный (из тарифов)' },
                  { value: 'manual', label: 'Ручной ввод ставки при выплате' },
                ]}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Отображение */}
      <div>
        <div style={{
          fontSize: '13px', fontWeight: 700, color: 'var(--text-tertiary)',
          textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px'
        }}>
          Отображение
        </div>
        <div style={{
          padding: '14px 16px', background: 'var(--surface-hover)', borderRadius: '12px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: '14px', color: 'var(--text-primary)' }}>
              Скрывать архивных в зарплатах
            </div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '2px' }}>
              Архивные сотрудники не будут показаны в фильтрах вкладки «Зарплаты»
            </div>
          </div>
          <label style={{ position: 'relative', display: 'inline-block', width: 48, height: 26, cursor: 'pointer', flexShrink: 0 }}>
            <input
              type="checkbox"
              checked={settings.hideArchiveInSalary !== false}
              onChange={(e) => onChange('hideArchiveInSalary', e.target.checked)}
              style={{ opacity: 0, width: 0, height: 0 }}
            />
            <span style={{
              position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
              background: settings.hideArchiveInSalary !== false ? 'var(--wb-primary)' : 'var(--surface-border)',
              borderRadius: 26, transition: 'all 0.3s ease',
            }}>
              <span style={{
                position: 'absolute', height: 20, width: 20,
                left: settings.hideArchiveInSalary !== false ? 24 : 3, bottom: 3,
                background: 'white', borderRadius: '50%',
                transition: 'all 0.3s ease', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
              }}></span>
            </span>
          </label>
        </div>
      </div>
    </div>
  )
}
